import React, { useContext, useState, useEffect } from 'react'
import {message, Modal} from 'antd'
import { TailSpin } from 'react-loader-spinner';
import {AppState} from '../App'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ethers } from 'ethers';

const Register = () => {
    const useAppState = useContext(AppState);
    const [searchParams] = useSearchParams();
    const [isModalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [referrer, setReferrer] = useState("");

    useEffect(() => {
        async function getData() {
            let user = await useAppState.staticContract.userInfo(useAppState.id);
            let zeroAddr = 0;
            if(Number(user.referrer) == zeroAddr && useAppState.loaded) {
                setModalOpen(true);
            } else {
                setModalOpen(false);
            }
        }
        getData();
    },[useAppState.walletAddress, useAppState.change, useAppState.id]);

    useEffect(() => {
        let ref = searchParams.get("ref");
        if(ref !== null) {
          setReferrer(ref)
        } else {
        //   setReferrer("Invalid Referrer Link");
          setReferrer("invalid ref link");
        }
    }, []);

    let OkText = loading ? <TailSpin height={14} color='white' /> : <p>Register</p>;

    const register = async () => {
        setLoading(true);
        try {

            let _ref = referrer;
            let refInfo = await useAppState.staticContract.userInfo(_ref);
            let refIncome = await useAppState.staticContract.incomeInfo(_ref);

            if(useAppState.convert(refInfo.totalDeposit) * 2 > useAppState.convert(refIncome.totalIncome) && Number(refInfo.level) >= 10) {
                let _pendingRoyaltyUsers = await useAppState.staticContract.getPendingRoyaltyUsers(Number(refInfo.level) - 10);
                for(let i=0; i<_pendingRoyaltyUsers.length; i++) {
                    if(Number(referrer) == Number(_pendingRoyaltyUsers[i])) {
                        message.error("Referrer ID is in pending for royalty, try again after the complete period of Royalty Time.");
                        return;
                    }
                }
            }

            // const usdtContract = await useAppState.getUsdtContract();
            // if(useAppState.convert(await useAppState.staticUsdtContract.allowance(useAppState.walletAddress, useAppState.contractAddress)) < 100000) {
            //     let _tx = await usdtContract.approve(useAppState.contractAddress, ethers.parseEther("100000000000"));
            //     await _tx.wait();
            // }
        
            let contract = await useAppState.getContract();
            let tx = await contract.register(referrer, useAppState.walletAddress, {
                value: ethers.parseEther((useAppState.levels[1] + ((useAppState.levels[1] * useAppState.percent[1]) / 100)).toString())
                // value: "0"
            });
            await tx.wait();
            message.success("Sucessfully Registered");
            useAppState.setChange(useAppState.change + 1);
        } catch (error) {
            message.error(error.reason);
            console.log(error);
        }
        setLoading(false);
    }

  return (
    <div>
        <Modal title="Register" open={isModalOpen} closable={false} onOk={register} okText={OkText} cancelButtonProps={{className:'hidden'}} >
            <div className='flex w-full flex-col justify-center items-center'>
                <img src='register.png' className='h-24' />
                <p className='text-sm font-medium break-all'>Referrer Id: {referrer == "17534" ? "default Refer" : referrer}</p>
                <p className='text-sm font-medium break-all'>Joining Fee: {useAppState.levels[1] + ((useAppState.levels[1] * useAppState.percent[1]) / 100)} BNB</p>
            </div>
        </Modal>
    </div>
  )
}

export default Register